import { Button, Result } from 'antd-mobile';
import { RedoOutline } from 'antd-mobile-icons';
import s from './style.module.less';

export function ErrorTenantNotFoundPage() {
  return (
    <div className={s.root}>
      <Result
        className={s.result}
        description="当前访问地址没有匹配的企业，请检查链接是否完整，或联系管理员确认企业编码。"
        status="warning"
        title="未找到当前企业"
      />
      <Button color="primary" onClick={() => window.location.reload()}>
        <RedoOutline />
        重新加载
      </Button>
    </div>
  );
}
